import { switchClasses } from '@mui/material';
import { green, grey } from '../../theme/palette/colors';
/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiSwitch to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/switch/#css
 */ export const MuiSwitch = {
    defaultProps: {
        color: 'primary'
    },
    // MUI doesn't provide the needed level of granularity via content slots, so overriding
    // with CSS classes instead
    styleOverrides: {
        root: {
            padding: 9
        },
        switchBase: ({ theme })=>({
                margin: 1,
                [`&.${switchClasses.checked}`]: {
                    [`& + .${switchClasses.track}`]: {
                        backgroundColor: green[600],
                        opacity: 1
                    }
                },
                [`&.${switchClasses.disabled}`]: {
                    [`& > .${switchClasses.thumb}`]: {
                        backgroundColor: theme.palette.mode === 'light' ? grey[100] : grey[700]
                    },
                    [`& + .${switchClasses.track}`]: {
                        opacity: 0.3
                    }
                }
            }),
        thumb: ({ theme })=>({
                backgroundColor: theme.palette.common.white,
                height: 18,
                width: 18
            }),
        track: ({ theme })=>({
                backgroundColor: theme.palette.mode === 'light' ? grey[400] : grey[600],
                borderRadius: 12,
                opacity: 1
            })
    }
};

//# sourceMappingURL=switch-overrides.js.map